import React, { Component, Fragment } from 'react';
import { MessageBars } from '../Outils/MessageBars';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { DetailsListReport } from './DetailsListReport';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataRapportCategorie } from '../../data/DataRapportCategorie';

import './DetailsListReport.css';
import { EUIComboBox } from '../EUI/EUIComboBox';

const INITIAL_OPTIONS = [
    { key: 'Excel', text: 'Excel' },
    { key: 'PDF', text: 'PDF' },
    { key: 'CSV', text: 'CSV' }
];

var objetState = {
    items: [],
    typeFormat: 'Excel',

    peutAccederReporting: false,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: null,

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    warningMessage: '',
    errorMessage: ''
};

export class DetailsListReporting extends Component {
    _creationContent() {
        let content = [];
        let typeFormat = this.state.typeFormat;

        this.state.items.forEach(function (value, index) {
            content.push(<div key={index} style={{ margin: '10px' }}>
                <h3 className="ms-font-xl titreRapportCategorie">{value.categorie}</h3>
                <DetailsListReport idRapportCategorie={value.idRapportCategorie} typeFormat={typeFormat} />
            </div>);
        });

        return (<div>{content}</div>);
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des catégories de rapport en cours'
        });

        let chargementDesRapportsCategorie = DataRapportCategorie._chargementDesRapportsCategorie();

        chargementDesRapportsCategorie
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    //let listeCategoriesRapports = responseFetch.reponseAPIobjet[0];
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (responseFetch.reponseAPIobjet[0] !== null ? responseFetch.reponseAPIobjet[0] : []);
                    let peutAccederReporting = responseFetch.reponseAPIobjet[1];

                    this.setState({
                        items: listeItem,

                        peutAccederReporting: peutAccederReporting,

                        enCoursDeTraitement: false,
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutAccederReporting = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }

    render = () => {

        const content = this._creationContent();

        return this.state.peutAccederReporting && <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        <Sticky stickyPosition={StickyPositionType.Header}>
                            <EUIComboBox
                                avecValeurDefaut={false}
                                label="Sélectionnez un format de téléchargement"
                                onChange={(event, option) => this.setState({ typeFormat: option.key })}
                                options={INITIAL_OPTIONS}
                                selectedKey={this.state.typeFormat}
                                style={{ marginBottom: '20px', marginLeft: '10px', maxWidth: '300px' }}
                            />
                        </Sticky>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

        </Fragment>;
    }
}